var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup9831111(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 870,
    viewBox: "0 0 1440 870",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1438.89 425.525L1439 425.461V1078H-1V425.461C89.1592 330.547 615.713 423.299 965.365 459.79C1314.69 496.251 1398.66 448.436 1438.89 425.525Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.112017 436.899L0 436.997V-99H1440V436.997C1349.84 514.903 823.287 438.727 473.635 408.752C124.307 378.805 40.343 418.077 0.112017 436.899Z",
    fill: "url(#paint0_linear_1258_1098)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1258_1098",
    x1: 0.00000274864,
    y1: 286,
    x2: 1952.5,
    y2: 282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40186D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F5AFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9831111);
export default __webpack_public_path__ + "static/media/Group-983-1-1-1-1.d299c5a85fdc5851d2c2888858ed1f7a.svg";
export { ForwardRef as ReactComponent };